/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Ajs dependency token for the Root Store Service.
 */
export const STORE_TOKEN = 'ngrxStoreService';
